import { useState } from "react";
import "./App.css";

function App() {
  const users = [
    {
      name: "Darth vader",
      pic: "https://filestore.community.support.microsoft.com/api/images/3c4dc47e-3f3e-4cbe-88a3-ee9c0676a652?upload=true",
    },
    {
      name: "Zoro",
      pic: "https://64.media.tumblr.com/4ecbe2d1dfe5b036473698a327ab4bce/e7dba1dd3de9daae-5c/s540x810/d6f2ac25d91bcad8886661702e5a559efe18268f.gif",
    },
    {
      name: "Sanji",
      pic: "https://i.pinimg.com/originals/92/3d/50/923d50b135b2c1034f91787705d29b03.gif",
    },
    {
      name: "Luffy",
      pic: "https://64.media.tumblr.com/4ecbe2d1dfe5b036473698a327ab4bce/e7dba1dd3de9daae-5c/s540x810/d6f2ac25d91bcad8886661702e5a559efe18268f.gif",
    },
  ];
  const movies = [
    {
      name: "Interstellar",
      poster: "https://m.media-amazon.com/images/I/A1JVqNMI7UL._SL1500_.jpg",
      rating: 8.6,
      summary: ` When Earth becomes uninhabitable in the future, a farmer and ex-NASA
  pilot, Joseph Cooper, is tasked to pilot a spacecraft, along with a team
  of researchers, to find a new planet for humans.`,
    },
    {
      name: "Baahubali",
      poster: "https://flxt.tmsimg.com/assets/p11546593_p_v10_af.jpg",
      rating: 8,
      summary: `In the kingdom of Mahishmati, Shivudu falls in love with a young warrior woman. While trying to woo her, he learns about the conflict-ridden past of his family and his true legacy.`,
    },
    {
      name: "Ratatouille",
      poster:
        "https://resizing.flixster.com/gL_JpWcD7sNHNYSwI1ff069Yyug=/ems.ZW1zLXByZC1hc3NldHMvbW92aWVzLzc4ZmJhZjZiLTEzNWMtNDIwOC1hYzU1LTgwZjE3ZjQzNTdiNy5qcGc=",
      rating: 8,
      summary: `Remy, a rat, aspires to become a renowned French chef. However, he fails to realise that people despise rodents and will never enjoy a meal cooked by him.`,
    },

    {
      name: "96",
      poster:
        "https://a10.gaanacdn.com/gn_img/albums/9En3peWXDV/En3pYMLPWX/size_xxl_1535086576.webp",
      rating: 8.6,
      summary: `K Ramachandran, a photographer, gets nostalgic after he visits his school in his hometown. During a reunion with his classmates, he meets Janaki, his childhood sweetheart.`,
    },

    {
      name: "M.S. Dhoni: The Untold Story",
      poster: "https://m.media-amazon.com/images/I/71miTEyKvYL._SL1112_.jpg",
      rating: 7.9,
      summary: `M S Dhoni, a boy from Ranchi, aspires to play cricket for India. Though he initially tries to please his father by working for the Indian Railways, he ultimately decides to chase his dreams.`,
    },
  ];
  return (
    <div className="App">
      {/* <Msg
        name="Darth vader"
        pic="https://filestore.community.support.microsoft.com/api/images/3c4dc47e-3f3e-4cbe-88a3-ee9c0676a652?upload=true"
      />
      <Msg
        name="Zoro"
        pic="https://64.media.tumblr.com/4ecbe2d1dfe5b036473698a327ab4bce/e7dba1dd3de9daae-5c/s540x810/d6f2ac25d91bcad8886661702e5a559efe18268f.gif"
      />
      <Msg
        name="Sanji"
        pic="https://i.pinimg.com/originals/92/3d/50/923d50b135b2c1034f91787705d29b03.gif"
      /> */}
      {/* Transform - map -> Array of string -> Array of JSX */}

      {/* {users.map((user) => (
        <Welcome name={user} />
      ))} */}

      {/* {users.map((user) => (
        <Msg name={user.name} pic={user.pic} />
      ))} */}

      {/* <Counter /> */}
      <div className="movie-list">
        {movies.map((mv) => (
          <Movie
            name={mv.name}
            poster={mv.poster}
            rating={mv.rating}
            summary={mv.summary}
          />
        ))}
      </div>
    </div>
  );
}

// pass data from parent to Child -> Props
function Movie({ name, poster, rating, summary }) {
  return (
    <div className="movie-container">
      <img className="movie-poster" src={poster} alt={name} />
      <div className="movie-specs">
        <h3 className="movie-name">{name}</h3>
        <p className="movie-rating">⭐{rating}</p>
      </div>
      <p>{summary}</p>
    </div>
  );
}

function double(n) {
  return [n, n * 2];
}

// import { useState } from "react";
// hook - If it is a hook (function) it will start with "use"
function Counter() {
  const [like, setLike] = useState(0);
  const [disLike, setDisLike] = useState(0);
  return (
    <div>
      <button onClick={() => setLike(like + 1)}>👍 {like}</button>
      <button onClick={() => setDisLike(disLike + 1)}>👎 {disLike}</button>
    </div>
  );
}

// // import { useState } from "react";
// // hook - If it is a hook (function) it will start with "use"
// function Counter() {
//   // const like = 1;
//   const [like, setLike] = useState(0); // Initial Value for like
//   const [disLike, setDisLike] = useState(0);
//   // setLike is the function will help to update like
//   // like++;

//   // state - current scenario - current data - web app
//   // state (like), setState (setLike) -> updates state
//   return (
//     <div>
//       <button onClick={() => setLike(like + 1)}>👍 {like}</button>
//       <button onClick={() => setDisLike(disLike + 1)}>👎 {disLike}</button>
//       {/* onClick - it pascal case - "C" caps*/}
//       {/* click Like button
//          ->   onClick
//         ->  setLike (will update like)
//         -> React will update the like in the view (screen)*/}
//       {/* <p>{like}</p> */}
//     </div>
//   );
// }

// function Msg(props) {
//   return (
//     <div>
//       <img height="300" src={props.pic} alt={props.name} />
//       <h1 className="name">Hi, {props.name}😊!!!</h1>
//     </div>
//   );
// }

function Msg({ name, pic }) {
  return (
    <div>
      <img height="300" src={pic} alt={name} />
      <h1 className="name">Hi, {name}😊!!!</h1>
    </div>
  );
}

function Welcome({ name }) {
  return <h1 className="name">Hi, {name}😊!!!</h1>;
}

export default App;

// React Web app - Best features
// 1. SPA - Single Page Application - no reload - index.html
// 2. Reusability

// Task
// // Movie list - 5 - 10
// 1. Interstellar
// 2. Sarpatta parambarai
// 3. Sherlock homles
// 4. Matrix

// // Movie details - 4
// 1. Movie poster
// 2. Movie name
// 3. Short summary
// 4. Ratings
